import Header from "../../componentes/header";
import Receitas from "../../componentes/receitas";

export default function Home() {
  return (
    <div>
      <Header />
      <Receitas />
    </div>
  );
}
